import { useContext, useEffect, useState } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AddIcon from "@material-ui/icons/Add";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";

import {
  HeaderAccordion,
  TableContent,
  IconButtonStyled,
} from "../styles/Cliente";
import useClienteController from "../controllers/ClienteController";
import TableDefault from "../../../../components/grid/TableDefault";
import { ClienteContext } from "../contexts/ClienteContext";
import ModalClienteRelacionado from "./ModalClienteRelacionado";
import Chip from "../../../../components/basics/Chip";

const columns = [
  {
    id: "acoes",
    label: "Ações",
    align: "center",
    flex: 1,
  },
  {
    id: "id",
    label: "Id",
    align: "center",
    flex: 1,
  },
  {
    id: "name",
    label: "Razão",
    flex: 1,
  },
  {
    id: "type",
    label: "Tipo",
    align: "center",
    flex: 1,
  },
  {
    id: "position",
    label: "Posição",
    align: "center",
    flex: 1,
  },
];

export default function AccordionClienteRelacionado() {
  const { expanded, relationship, errors } = useContext(ClienteContext);
  const { handleChangeOpenAcordion, handleRemoveRelationship } =
    useClienteController();
  const [open, setOpen] = useState(false);
  const [dataTable, setDataTable] = useState([]);

  useEffect(() => {
    (() => {
      const newList = relationship.map((item, index) => {
        return {
          ...item,
          acoes: (
            <div>
              <Tooltip title="Deletar">
                <IconButton
                  onClick={() => handleRemoveRelationship(item, index)}
                >
                  <DeleteOutlineOutlinedIcon />
                </IconButton>
              </Tooltip>
            </div>
          ),
        };
      });

      setDataTable(newList);
    })();
  }, [relationship, handleRemoveRelationship]);

  return (
    <>
      {open && <ModalClienteRelacionado open={open} setOpen={setOpen} />}
      <Grid item xs={12}>
        <Accordion expanded={expanded.relationship || false}>
          <AccordionSummary
            expandIcon={
              <ExpandMoreIcon
                onClick={() => handleChangeOpenAcordion("relationship")}
              />
            }
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <HeaderAccordion>
              <Grid container spacing={1} alignItems="center">
                <Grid
                  item
                  xs
                  onClick={() => handleChangeOpenAcordion("relationship")}
                >
                  <Chip
                    label="RELACIONADOS"
                    bgcolor={
                      !expanded.relationship &&
                      errors.accordions &&
                      errors.accordions.includes("relationship")
                        ? "red"
                        : "default"
                    }
                  />
                </Grid>
                <Grid item flex={1}>
                  <Tooltip title="Adicionar relacionado">
                    <IconButtonStyled onClick={() => setOpen(true)}>
                      <AddIcon />
                    </IconButtonStyled>
                  </Tooltip>
                </Grid>
              </Grid>
            </HeaderAccordion>
          </AccordionSummary>

          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TableContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TableDefault
                        columns={columns}
                        values={dataTable}
                        tableTitle=""
                      />
                    </Grid>
                  </Grid>
                </TableContent>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </>
  );
}
